import React from 'react';
import SignUpWithEmail from '../components/SignUpV3/SignUpWithEmail';

/**
 * @deprecated
 */
export const SignUpWithEmailV3Route = () => {
    return <SignUpWithEmail />;
};
